import React from 'react';
import Grid from '@material-ui/core/Grid';
import Counter from './counter';
import PickupRequest from './pickupRequest';
import ParcelStatusLineChart from './parcelStatusLineChart';

export default function RiderDashboard() {
  return (
    <Grid container>
      <Grid item xs={12} container spacing={1} className="pb-5" justifyContent="center" alignItems="center">
        <PickupRequest />
        <Counter />
      </Grid>

      <Grid item xs={12} className="pb-5">
        <ParcelStatusLineChart />
      </Grid>
    </Grid>
  );
}
